const root = "Auth";
export const SET = `${root}/set`;
export const SET_TOKEN = `${root}/set_token`;
export const SET_INITIAL = `${root}/set_initial`;
export const RESET_STORE = `${root}/reset_Store`;
export const LOADER = `${root}/loader`;
